import { render, staticRenderFns } from "./DownPaymentExtOrderItemTable.vue?vue&type=template&id=219ed1ca&scoped=true&"
import script from "./DownPaymentExtOrderItemTable.vue?vue&type=script&lang=ts&"
export * from "./DownPaymentExtOrderItemTable.vue?vue&type=script&lang=ts&"
import style0 from "./DownPaymentExtOrderItemTable.vue?vue&type=style&index=0&id=219ed1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ed1ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
